// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__ZE01H","content-area":"layout_content-area__Mh+YW"};